import React from 'react';
import { Alert, Box, Grid, Paper, Stack, Typography } from '@mui/material';

type Props = {
  title?: string;
  subtitle?: string;
  master: React.ReactNode;
  detail?: React.ReactNode;
  selected?: any;
  emptyDetailMessage?: string;
  masterSize?: any;
  detailSize?: any;
};

class FMasterDetailPanel extends React.PureComponent<Props> {
  render() {
    const p = this.props;
    const masterSize = p.masterSize || { xs: 12, lg: 7 };
    const detailSize = p.detailSize || { xs: 12, lg: 5 };

    return (
      <Stack spacing={2}>
        {(p.title || p.subtitle) && (
          <Box>
            {p.title && <Typography variant="h6" sx={{ fontWeight: 800 }}>{p.title}</Typography>}
            {p.subtitle && <Typography variant="body2" color="text.secondary">{p.subtitle}</Typography>}
          </Box>
        )}

        <Grid container spacing={2}>
          <Grid size={masterSize}>{p.master}</Grid>
          <Grid size={detailSize}>
            {p.selected || p.detail ? p.detail : (
              <Paper elevation={1} sx={{ p: 2 }}>
                <Alert severity="info">{p.emptyDetailMessage || 'Select a record from the grid to view or edit details.'}</Alert>
              </Paper>
            )}
          </Grid>
        </Grid>
      </Stack>
    );
  }
}

export default FMasterDetailPanel;
